<template>
  <div id="app">
    <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
      <a class="navbar-brand col-sm-3 col-md-2 mr-0" href="#">Hofman</a>
      <a
        v-if="$router.currentRoute.path !== '/login'"
        class="navbar-brand col-sm-3 col-md-2 mr-0 btnLogout"
        @click="logout()"
        >Uitloggen</a
      >
    </nav>

    <div
      v-if="
        $router.currentRoute.path !== '/login' &&
          $router.currentRoute.path !== '/wachtwoord-vergeten' &&
          $router.currentRoute.path !== '/nieuw-wachtwoord'
      "
      class="container-fluid"
    >
      <div class="row">
        <nav class="col-md-2 d-none d-md-block bg-light sidebar">
          <div class="sidebar-sticky">
            <ul class="nav flex-column">
              <li class="nav-item">
                <a class="nav-link active" href="/overzicht">Overzicht</a>
              </li>
              <template v-if="this.$store.getters.user && this.$store.getters.user.type == 'Administrator'">
                <li class="nav-item">
                  <a class="nav-link" href="/bestellingen">Bestellingen</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/leveringen">Leveringen</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/chauffeurs">Chauffeurs</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/vrachtwagens">Vrachtwagens</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/containers">Containers</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/werven">Werven</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/klanten">Klanten</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/stortplaatsen">Stortplaatsen</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/afvalproducten">Afvalproducten</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/leveringsproducten">Leveringsproducten</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/transportzones">Transport Zones</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/gebruikers">Gebruikers</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="/instellingen">Instellingen</a>
                </li>
              </template>
            </ul>
          </div>
        </nav>

        <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-0">
          <router-view></router-view>
        </main>
      </div>
    </div>

    <div
      v-if="
        $router.currentRoute.path == '/login' ||
          $router.currentRoute.path == '/wachtwoord-vergeten' ||
          $router.currentRoute.path == '/nieuw-wachtwoord'
      "
      class="container-fluid"
    >
      <div class="row">
        <main role="main" class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 px-0">
          <router-view></router-view>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";

export default {
  name: "App",
  components: {},
  computed: {},
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style>
.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  padding: 48px 0 0;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
}

html,
body {
  height: 100%;
}

.container-fluid,
.row {
  height: 100%;
}

.navbar .btnLogout {
  font-size: 14px;
}

@media (min-width: 768px) {
  [role="main"] {
    padding-top: 48px;
  }
}
</style>
